import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class ImageAPI extends ComponentAPI {
    getSrc() {
        return this.state.src;
    }
    setSrc(src) {
        this.setState({ src });
    }
    isVisible() {
        return this.state.visible;
    }
    setVisible(visible) {
        this.setState({ visible });
    }
    isLoading() {
        return this.state.loading ?? false;
    }
    setLoading(loading) {
        this.setState({ loading });
    }
    getWidth() {
        return this.state.width;
    }
    setWidth(width) {
        this.setState({ width });
    }
    getHeight() {
        return this.state.height;
    }
    setHeight(height) {
        this.setState({ height });
    }
    getAlt() {
        return this.state.alt;
    }
    setAlt(alt) {
        this.setState({ alt });
    }
    getMinWidth() {
        return this.state.minWidth;
    }
    setMinWidth(minWidth) {
        this.setState({ minWidth });
    }
    getMaxWidth() {
        return this.state.maxWidth;
    }
    setMaxWidth(maxWidth) {
        this.setState({ maxWidth });
    }
    getMinHeight() {
        return this.state.minHeight;
    }
    setMinHeight(minHeight) {
        this.setState({ minHeight });
    }
    getMaxHeight() {
        return this.state.maxHeight;
    }
    setMaxHeight(maxHeight) {
        this.setState({ maxHeight });
    }
    getPreventContextMenu() {
        return Boolean(this.state.preventContextMenu);
    }
    setPreventContextMenu(preventContextMenu) {
        this.setState({ preventContextMenu });
    }
}
export default ImageAPI;
//# sourceMappingURL=image-api.js.map